<template>
    <v-dialog v-model="formdialog" >
        <v-card>
            <v-container fluid>
                <h1>GM New Purchase</h1>
                <v-form @submit.prevent="">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-autocomplete
                                label="Vendor Name"
                                v-model="bill.vname"
                                :items="vendors"
                                item-title="vname"
                                item-value="vname"
                                density="default"
                                placeholder="Vendor name"
                                auto-select-first
                                item-props
                                clearable  
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Challan" v-model="bill.challans" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Bill No" v-model="bill.billno" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Bill Date" v-model="bill.billdate" type='date' required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Taxable" v-model="bill.pur_taxable" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="IGST" v-model="bill.pur_igst" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="CGST" v-model="bill.pur_cgst" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="SGST" v-model="bill.pur_sgst" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="CESS" v-model="bill.pur_cess" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Amount" v-model="bill.amnt" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Pay 1" v-model="bill.pay1" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Date 1" v-model="bill.d1" type='date' required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Details 1" v-model="bill.details1" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Pay 2" v-model="bill.pay2" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Date 2" v-model="bill.d2" type='date' required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Details 2" v-model="bill.details2" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-text-field label="Note" v-model="bill.note" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="auto">
                        <v-btn
                            depressed
                            color="primary"
                            type="submit"
                            @click=buttonClick()
                        >
                            Save
                        </v-btn>
                        </v-col>
                        <v-col cols="auto">
                        <v-btn
                            v-if="editedIndex != -1"
                            depressed
                            color="error"
                            type="submit"
                            @click=deleteData()
                        >
                            Delete
                        </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <div v-if="showMessage">
                    <ShowError @closesnackbar="closesnackbar"/>
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script setup>
import { ref, provide, computed, onMounted,onBeforeMount,watch } from 'vue'
import { useAuthStore } from '@/stores/AuthStore'
import VendorService from '@/services/VendorService'
import PurchaseService from '@/services/PurchaseService'
import ShowError from '@/components/Showerror'

const props = defineProps(['showGmForm','editedItem','editedIndex','updateID'])
const emit = defineEmits(['closegmdialog'])

var formdialog = ref(props.showGmForm)
var vendors = ref([])

var bill = ref(props.editedItem)
var vendorname = ref('')

var showMessage = ref(false)
var msgStatus = ref('primary')
var msg = ref('This is msg')

provide('msgStatus', msgStatus)
provide('msg', msg)
provide('showMessage', showMessage)

function closesnackbar (){
    showMessage.value = false
}

async function getgmvendors(){
    try{
        var parties = (await VendorService.getall()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    vendors.value = parties
    return parties
}

async function create(){
    //console.log(bill.value)
    try{
        await PurchaseService.create(bill.value)
        formdialog.value = false
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
}

async function update(){
    console.log(bill.value)
    console.log("Update ID is "+props.updateID)
    try{
        await PurchaseService.update(bill.value, props.updateID)
        formdialog.value = false
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
}

async function buttonClick(){
    if(props.editedIndex == -1){
        await create()
    }else{
        await update()
    }
}

onBeforeMount(async () => {
    await getgmvendors()
    console.log(vendors.value)

})

watch(formdialog, async(val)=>{
    if(formdialog.value===false){
        emit('closegmdialog')
    }
})

</script>